module.exports = __webpack_public_path__ + "static/media/barberscape-replacement-blade-3.bb1cadf6.png";